import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
export interface AddItemDialogData
{
    readonly description: string;
}
@Component({
    selector: "add-item-dialog-component",
    templateUrl: "./addItemDialog.tmpl.html",
    standalone: false
})
export class AddItemDialogComponent
{
    constructor(
        private readonly dialogRef: MatDialogRef<AddItemDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private readonly data: AddItemDialogData
    ) { }

    get description(): string
    {
        return this.data.description;
    }
}
